<template>
    <header class="head-top">
        <!--登录状态下的头部 isLogin = true -->
        <!--未登录状态下的头部 isLogin = false;-->
        <div class="main-container">
            <img class="logoImg" @click="toFirst" src="../../assets/images/topBar1/logoIcon.png"/>
            <el-menu :default-active="$root.activeIndex" ref="menus"
                     :activeIndex="$root.activeIndex"
                     :class="{headActive : headActive}"
                     class="head-menu" mode="horizontal" @select="$root.handleSelect">
                <el-menu-item index="home" @click="toFirst">首页</el-menu-item>
                <el-menu-item index="invite" @click="toSecond">招标公告</el-menu-item>
                <el-menu-item index="win" @click="toThird">中标公告</el-menu-item>
                <el-menu-item index="setting" @click="toFourth">帮助中心</el-menu-item>
            </el-menu>
            <div class="head-right" v-if="!isLogin">
                <span class="login" @click="$router.push('/login/masterCenter')">登录</span>
                <span class="line"></span>
                <span class="register" @click="$router.push('/register')">注册</span>
                <span class="line"></span>
                <span class="standard" @click="toStandard" title="供应商入库标准">供应商入库标准</span>
                <span class="help" @click="toFourth" title="帮助中心"></span>
                <!--<el-popover
                    placement="bottom"
                    width="260"
                    trigger="hover">
                    <img src="../../assets/images/masterCenter/topBar/QRCode.jpg" >
                    <span slot="reference" class="wechat"></span>
                </el-popover>-->
            </div>
            <div class="head-right" v-else>
                <span class="login" @click="toMaster">返回管理中心</span>
                <span class="line"></span>
                <!--<span class="register" :title="companyName">Hi，{{ companyName }} </span>-->
                <el-tooltip :disabled="companyName.length < 13" :content="companyName" placement="bottom" effect="light">
                    <span class="register" >Hi，{{ companyName }} </span>
                </el-tooltip>
                <span class="line"></span>
                <span class="standard" @click="toStandard" title="供应商入库标准">供应商入库标准</span>
                <span class="help" @click="toFourth" title="帮助中心"></span>
                <!-- <el-popover
                    placement="bottom"
                   width="260"
                    trigger="hover">
                    <img src="../../assets/images/masterCenter/topBar/QRCode.jpg" >
                    <span slot="reference" class="wechat"></span>
                </el-popover> -->
                <span class="loginOut" @click="toLoginOut">退出</span>
            </div>
        </div>
    </header>
</template>

<script type="text/babel">
    import Vue from 'vue'
    export default Vue.component('my-header',{
        data () {
            return {
                isLogin:  window.sessionStorage.getItem('refresh_token') ? true : false ,
                companyName: window.sessionStorage.getItem('companyName'),
                headActive: false,
            }
        },
        created(){

        },
        methods: {
            toLoginOut(){
//                let currentUrl = (window.location.href).split('?')[0];
//                this.$router.push('/login/'+encodeURIComponent(currentUrl));
                window.sessionStorage.clear();
                this.$router.push('/login/masterCenter');
                this.$root.isLogin = false;
            },
            toFirst(){
                this.$root.activeIndex = 'home';
                this.$router.push( '/');
            },
            toSecond(){
                this.$root.activeIndex = 'invite';
                this.$router.push( '/invite-list');
            },
            toThird(){
                this.$root.activeIndex = 'win';
                this.$router.push( '/win-list');
            },
            toFourth(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
            toStandard(){
                this.$router.push( '/supplierAddStandard');
            },
            toMaster(){
                this.$root.activeIndex = 'home';
                this.$router.push('/master/center');
            },
            handleScroll(){
                var headerElA = document.getElementsByTagName('header');
                var headerEl = headerElA.length ? headerElA[0] : '';
                var loginRightEl = document.getElementsByClassName('loginRight');
                if( !headerEl ){
                    return;
                }
                let innerHeight = document.documentElement.clientHeight;
                let scrollTop = document.documentElement.scrollTop;
                if(scrollTop+80 > innerHeight/2){
                    headerEl.className = 'head-top head-top-bg';
                    if(loginRightEl.length){
                        loginRightEl[0].className = 'loginRight';
                    }
                } else {
                    headerEl.className = 'head-top';
                    if(loginRightEl.length){
                        loginRightEl[0].className = 'loginRight loginIndex';
                    }
                }
            }
        },
        mounted(){
            if(this.$route.name == 'index'){
                this.headActive = true;
                window.addEventListener('scroll',this.handleScroll);
            } else {
                window.removeEventListener('scroll',this.handleScroll);
            }
        }
    })

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../../assets/_var.scss';
    .headActive .el-menu-item{
        /*color: #ffffff !important;*/

    }
    .el-menu-item{
        font-size: 18px;
    }
    .el-breadcrumb {
        height: 44px;
        line-height: 44px;
    }
    .head-top {
        /*position: absolute;*/
        position: fixed;
        left: 0;
        top: 0;
        right: 17px;
        z-index: 9;
        width: 100%;
        height: 60px;
        /*background: rgba(255,255,255,1);*/
        background: rgba(155, 185, 221, 0.65);
        transition: .5s;
        & .line {
            width: 1px;
            height: 12px;
            background: #fff;
        }
        & .loginRight {
            border-bottom: 1px solid $--secondary-fill-color;
            p {
                text-align: right;
                font-size: 12px;
                color: $--text-color-light;
                line-height: 20px;
                span {
                    display: inline-block;
                    vertical-align: middle;
                }
                span:nth-of-type(odd) {
                    padding-left: 35px;
                    padding-right: 14px;
                    cursor: pointer;
                }
                .backIndex {
                    background: url('../../assets/images/masterCenter/topBar/icon01.png') no-repeat 10px center;
                }
                .helpT {
                    background: url('../../assets/images/masterCenter/topBar/icon02.png') no-repeat 10px center;
                }
                .standardT {
                    background: url('../../assets/images/topBar1/standard2.png') no-repeat 10px center / 16px 16px;
                }
                .wechatT {
                    background: url('../../assets/images/masterCenter/topBar/icon03.png') no-repeat 10px center;
                }
                .loginOut {
                    background: url('../../assets/images/masterCenter/topBar/icon04.png') no-repeat 10px center;
                }
                .line {
                    background: $--text-color-light;
                }
            }
        }
        & .loginIndex {
            border-bottom: 1px solid #fff;
            p {
                color: #fff;
                .backIndex {
                    background: url('../../assets/images/masterCenter/topBar/icon_01.png') no-repeat 10px center;
                }
                .helpT {
                    background: url('../../assets/images/masterCenter/topBar/icon_02.png') no-repeat 10px center;
                }
                .standardT {
                    background: url('../../assets/images/topBar1/standard.png') no-repeat 10px center / 16px 16px;
                }
                .wechatT {
                    background: url('../../assets/images/masterCenter/topBar/icon_03.png') no-repeat 10px center;
                }
                .loginOut {
                    background: url('../../assets/images/masterCenter/topBar/icon_04.png') no-repeat 10px center;
                }
                .line {
                    background: #fff;
                }
            }
        }
    }
    .head-top-white {//头部背景为白色
        background: rgba(255,255,255,1);
    }
    .head-top .main-container {
        background: none;
        overflow: hidden;
    }
    .logoImg {
        float: left;
        vertical-align: middle;
        margin: 15px 0px 0 0;
        width: 280px;
        height: 35px;
        cursor: pointer;
    }
    .el-menu {
        float: left;
        vertical-align: middle;
        border: none;
        background: none;
    }
    .head-right {
        margin-top: 16px;
        float: right;
        vertical-align: middle;
        color: #fff;
        font-size: 16px;
        position: absolute;
        right: 20px;
        font-size: 14px;
    }
    .head-right span {
        display: inline-block;
        margin: 0 2px;
        vertical-align: middle;
        cursor: pointer;
    }
    .head-right .register {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .login {
        line-height: 28px;
        background: url('../../assets/images/topBar1/icon03.png') no-repeat 0 1px;
        padding-left: 28px;
        padding-right: 5px;
    }
    .register {
        line-height: 28px;
        background: url('../../assets/images/topBar1/icon04.png') no-repeat 0 1px;
        padding-left: 26px;
    }
    .standard {
        /*margin-left: 20px;*/
        line-height: 28px;
        padding-left: 25px;
        background: url('../../assets/images/topBar1/standard.png') no-repeat 5px center / 16px 16px;
    }
    .head-right .help {
        margin-left: 5px;
        width: 28px;
        height: 28px;
        background: url('../../assets/images/topBar1/icon01.png') no-repeat;
     }
    .wechat {
        width: 28px;
        height: 28px;
        background: url('../../assets/images/topBar1/icon02.png') no-repeat;
    }
    .el-menu--horizontal > .el-menu-item {
        color: $--text-color;
        height: 58px;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
        font-weight: 700;
        color: $--text-color;
        background: none;
     }
    .el-menu--horizontal .el-menu-item:hover, .el-menu--horizontal .el-menu-item:focus {
        color: $--text-color;
        background: none;
    }
    .head-top-bg {
        position: fixed;
        /*height: 60px;*/
        /*background: rgba(255, 255, 255, .8);*/
        background: #fff;
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .standard {
                background: url('../../assets/images/topBar1/standard2.png') no-repeat 5px center / 16px 16px;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
    }
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
        background: none;
        /*color: #fff;*/
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Header.vue